export default "__VITE_ASSET__CTIM6p54__"